
















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { TimeEntryGroupingModel } from '@/services/api/nswag/stapiclient_generated';
import StInput2 from '@/components/basic/StInput2.vue';
import { UserStore } from "@/store/user-module";

@Component({
  components: { StInput2 },
})
export default class TimeEntryFilterComponent extends Vue {
  @Prop() groupingModel!: TimeEntryGroupingModel;

  dateGroupingEnabledInternal = false;

  async mounted() {
    if (!this.groupingModel) {
      this.groupingModel = TimeEntryGroupingModel.fromJS({});
    }
  }

  get useProjectTimeTracking(){
    return !UserStore.userSettings.useBasicTimeTracking && !UserStore.userSettings.isBasicTimeTrackingUser
  }

  get isDayGrouped(){
    return this.groupingModel.groups?.some(x=>x == "EntryDate") ?? false;
  }

  set isDayGrouped(data: boolean){
    this.toggleGroupInModel(this.isDayGrouped, data, "EntryDate");
  }

  get isWeekGrouped(){
    return this.groupingModel.groups?.some(x=>x == "EntryWeek") ?? false;
  }

  set isWeekGrouped(data: boolean){
    this.toggleGroupInModel(this.isWeekGrouped, data, "EntryWeek");
  }

  get isMonthGrouped(){
    return this.groupingModel.groups?.some(x=>x == "EntryMonth") ?? false;
  }

  set isMonthGrouped(data: boolean){
    this.toggleGroupInModel(this.isMonthGrouped, data, "EntryMonth");
  }

  get isYearGrouped(){
    return this.groupingModel.groups?.some(x=>x == "EntryYear") ?? false;
  }

  set isYearGrouped(data: boolean){
    this.toggleGroupInModel(this.isYearGrouped, data, "EntryYear");
  }

  get isCustomerGrouped(){
    return this.groupingModel.groups?.some(x=>x == "CustomerName") ?? false;
  }

  set isCustomerGrouped(data: boolean){
    this.toggleGroupInModel(this.isCustomerGrouped, data, "CustomerName");
  }

  get isProjectGrouped(){
    return this.groupingModel.groups?.some(x=>x == "ProjectName") ?? false;
  }

  set isProjectGrouped(data: boolean){
    this.toggleGroupInModel(this.isProjectGrouped, data, "ProjectName");
  }

  get isAppUserGrouped(){
    return this.groupingModel.groups?.some(x=>x == "AppUserName") ?? false;
  }

  set isAppUserGrouped(data: boolean){
    this.toggleGroupInModel(this.isAppUserGrouped, data, "AppUserName");
  }

  get isProjectTaskGrouped(){
    return this.groupingModel.groups?.some(x=>x == "ProjectTaskNameNullChecked") ?? false;
  }

  set isProjectTaskGrouped(data: boolean){
    this.toggleGroupInModel(this.isProjectTaskGrouped, data, "ProjectTaskNameNullChecked");
  }

  toggleGroupInModel(oldVal: boolean, newVal: boolean, key: string){
    if(!this.groupingModel.groups){
      this.groupingModel.groups = [];
    }
    if(oldVal && !newVal){
      this.groupingModel.groups.splice(this.groupingModel.groups.indexOf(key), 1);
    }

    if(!oldVal && newVal){
      this.groupingModel.groups.push(key);
    }
  }

  get isGrouped() {
    return (
      this.isDayGrouped ||
      this.isWeekGrouped ||
      this.isMonthGrouped ||
      this.isYearGrouped ||
      this.isAppUserGrouped||
      this.isCustomerGrouped ||
      this.isProjectGrouped ||
      this.isProjectTaskGrouped
    );
  }

  get dateGroupingOptions() {
    return [
      {
        value: 'none',
        label: this.$t('Nicht gruppieren'),
      },
      {
        value: 'day',
        label: this.$t('Tag'),
      },
      {
        value: 'week',
        label: this.$t('Woche'),
      },

      {
        value: 'month',
        label: this.$t('Monat'),
      },

      {
        value: 'year',
        label: this.$t('Jahr'),
      },
    ];
  }

  get dateGrouping() {
    if (this.isDayGrouped) return 'day';

    if (this.isMonthGrouped) return 'month';

    if (this.isWeekGrouped) return 'week';

    if (this.isYearGrouped) return 'year';

    return 'none';
  }

  set dateGrouping(val: any) {
    switch (val) {
      case 'day':
        this.isDayGrouped = true;
        this.isWeekGrouped = false;
        this.isMonthGrouped = false;
        this.isYearGrouped = false;
        break;
      case 'week':
        this.isDayGrouped = false;
        this.isWeekGrouped = true;
        this.isMonthGrouped = false;
        this.isYearGrouped = false;
        break;
      case 'month':
        this.isDayGrouped = false;
        this.isWeekGrouped = false;
        this.isMonthGrouped = true;
        this.isYearGrouped = false;
        break;
      case 'year':
        this.isDayGrouped = false;
        this.isWeekGrouped = false;
        this.isMonthGrouped = false;
        this.isYearGrouped = true;
        break;
      case 'none':
        this.isDayGrouped = false;
        this.isWeekGrouped = false;
        this.isMonthGrouped = false;
        this.isYearGrouped = false;
        this.dateGroupingEnabledInternal = false;
        break;
    }

    this.applyGrouping();
  }

  get dateGroupingEnabled(): boolean {
    return this.isDayGrouped || this.isWeekGrouped || this.isMonthGrouped || this.isYearGrouped || this.dateGroupingEnabledInternal;
  }

  async enableDateGrouping() {
    this.dateGroupingEnabledInternal = true;
    await this.$nextTick();
    (this.$refs.dateGroup as any).open();
  }

  toggleGroup(groupName: string) {
    switch (groupName) {
      case 'day':
        this.isDayGrouped = !this.isDayGrouped;
        this.isWeekGrouped = false;
        this.isMonthGrouped = false;
        this.isYearGrouped = false;
        break;
      case 'week':
        this.isDayGrouped = false;
        this.isWeekGrouped = !this.isWeekGrouped;
        this.isMonthGrouped = false;
        this.isYearGrouped = false;
        break;
      case 'month':
        this.isDayGrouped = false;
        this.isWeekGrouped = false;
        this.isMonthGrouped = !this.isMonthGrouped;
        this.isYearGrouped = false;
        break;
      case 'year':
        this.isDayGrouped = false;
        this.isWeekGrouped = false;
        this.isMonthGrouped = false;
        this.isYearGrouped = !this.isYearGrouped;
        break;
      case 'customer':
        this.isCustomerGrouped = !this.isCustomerGrouped;
        break;
      case 'user':
        this.isAppUserGrouped = !this.isAppUserGrouped;
        break;
      case 'project':
        this.isProjectGrouped = !this.isProjectGrouped;
        break;
      case 'projecttask':
        this.isProjectTaskGrouped = !this.isProjectTaskGrouped;
        break;
      case 'details':
        this.groupingModel.details = !this.groupingModel.details;
        break;
    }

    this.applyGrouping();
  }

  @Emit('input')
  applyGrouping() {
    return this.groupingModel;
  }
}
